import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { abvOptions } from '../../utils/constants'
import classNames from 'classnames'
import { useFilterStore } from 'src/features/brewknowledge/state/filterStore'

const Abv: React.FC = () => {
    const {
        toggleAbvArrowUp,
        setToggleAbvArrowUp,
        setAbvFilter,
        abvSelections,
        setAbvSelections,
        setPage,
        setNextResultsOffset,
    } = useFilterStore()

    type abvOption = {
        label: string
        value: string
    }

    const handleOptionSelection = (item: abvOption) => {
        setPage(1)
        setNextResultsOffset(null)
        const falseAbvSelections = {
            'Non-Alcoholic (<2%)': false,
            'Low (2-4.5%)': false,
            'Normal (4.5-6.5%)': false,
            'Elevated (6.5-8.5%)': false,
            'High (8.5-12%)': false,
            'Extremely High (>12%)': false,
        }

        if (abvSelections[item.label]) {
            setAbvFilter(null)
            setAbvSelections({ ...falseAbvSelections, [item.label]: false })
        } else {
            setAbvSelections({
                ...falseAbvSelections,
                [item.label]: true,
            })
            setAbvFilter({
                min: +item.value.split(',')[0],
                max: +item.value.split(',')[1],
                label: item.label,
            })
        }
    }
    return (
        <div className='mb-4'>
            <div
                className={classNames(
                    'flex flex-col items-start justify-start space-y-2',
                    toggleAbvArrowUp ? 'mb-6' : ''
                )}
            >
                <UI.Button
                    label='ABV'
                    data-cy='filterAbv'
                    theme='link'
                    customClasses='flex flex-row-reverse justify-start text-dark pb-0 pl-0'
                    onClick={() => setToggleAbvArrowUp(!toggleAbvArrowUp)}
                    size='sm'
                >
                    <UI.Icon
                        slug='HeroIcons.ChevronRight'
                        size='sm'
                        customClasses={classNames(
                            toggleAbvArrowUp ? '-rotate-90' : '',
                            'text-gray-300 mr-2 pointer-events-none'
                        )}
                    />
                </UI.Button>

                <div
                    className={classNames(!toggleAbvArrowUp ? 'hidden' : '', 'flex flex-col pl-1')}
                >
                    {abvOptions.map((item, index) => (
                        <div key={`filterOption-${item.label}`} className='flex flex-col'>
                            <UI.InputGroup
                                type='radio'
                                id={`filterAbv-${item.label}`}
                                label={item.label}
                                placeholder={item.label}
                                customClasses='pt-2 input-group--brewknowledge'
                                checked={abvSelections[item.label]}
                                onClick={() => handleOptionSelection(item)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Abv
